import React from 'react'
import { Grid } from '@mui/material'

import PageWrapper from 'Pages/@PageWrapper'
import { TourProvider, TourTarget } from "@tour"
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import {isSystemBusy} from "@signals";
import AmazonReleaseDateFilters from "./Filters";
import {isEmptyAmazonReleaseDate} from "./@signals";
import AmazonReleaseDateTable from "./Table";
import AmazonReleaseDateReportFormDrawer from "./ReportForm";

export default function AmazonReleaseDatePage() {

    const props = {
        head: CUSTOM_DASHBOARD_ROUTES.AMAZON_RELEASE_DATE_TITLE,
        title: CUSTOM_DASHBOARD_ROUTES.AMAZON_RELEASE_DATE_TITLE,
        subtitle: CUSTOM_DASHBOARD_ROUTES.AMAZON_RELEASE_DATE_SUBTITLE,
        isEmpty: isEmptyAmazonReleaseDate.value,
        hasErrors: isSystemBusy.value,
        tourPageKey: "amazonReleaseDate"
    }

    return <PageWrapper {...props} filters={<AmazonReleaseDateFilters/>}>
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="amazon-release-date-table" height={350} />
                <AmazonReleaseDateTable />
            </Grid>
            <Grid item xs={12}>
                <AmazonReleaseDateReportFormDrawer />
            </Grid>
        </Grid>
    </PageWrapper>
}